import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import UUID from 'uuid'
import DtoSelection from '../../dto/DtoSelection'
import DtoSelectionSite from '../../dto/DtoSelectionSite'
import DtoSelectionFilter from '../../dto/DtoSelectionFilter'
import { differenceWith, filter, find, flatten, intersectionWith, isEqual, maxBy, orderBy, reduce, sumBy, uniqBy } from 'lodash'
import SelectionDeleteModal from '../../../components/modal/selection/SelectionDeleteModal'
import DtoFilter from '../../dto/DtoFilter'
import DtoFilterType from '../../../referential/dto/DtoFilterType'
import ResearchTypes from '../../../utils/ResearchTypes'
import DtoSelectionDetailSite from '../../../sites/dto/DtoSelectionDetailSite'
import DtoSiteType from '../../../referential/dto/DtoSiteType'
import ThemeDto from '../../../administration/dto/ThemeDto'
import DtoSelectionRow from '../../dto/DtoSelectionRow'
import AgGridTable from '../../../components/dataTable/AgGrid/AgGridTable'
import i18n from 'simple-react-i18n'
import { getDate } from '../../../utils/DateUtil'
import SelectionInformationModal from '../../../components/modal/selection/SelectionInformationModal'
import { formatNumber } from '../../../utils/NumberUtils'
import moment from 'moment/moment'
import DtoKeyFigures from '../../../sites/dto/DtoKeyFigures'
import DtoSelectionExportHistory from '../../dto/DtoSelectionExportHistory'
import DtoSelectionWatershed from '../../dto/DtoSelectionWatershed'
import LoadingPanel from '../../../components/loading/LoadingPanel'
import IndicatorPanel from '../indicator/IndicatorPanel'
import { getPlurial, getPlurialWithNumber, substringNumber } from '../../../utils/StringUtils'
import SelectionAction from '../../actions/SelectionAction'
import SitesAction from '../../../sites/actions/SitesAction'
import AppStore from '../../../store/AppStore'
import DtoCity from '../../../referential/dto/DtoCity'
import DtoWatershed from '../../../referential/dto/DtoWatershed'
import DtoManagementWater from '../../../referential/dto/DtoManagementWater'
import DtoSelectionStatus from '../../dto/DtoSelectionStatus'
import LinearProgress from '@material-ui/core/LinearProgress'
import { css } from 'glamor'
import { Icon } from '@material-ui/core'
import SelectionExportModal from '../../../components/modal/selection/SelectionExportModal'
import Tooltip from '@material-ui/core/Tooltip'
import DtoDepartment from '../../../referential/dto/DtoDepartment'
import SiteTypes from '../../../utils/mapUtils/SiteTypes'

const $ = window.$

class SelectionsPanel extends Component {

	constructor(props) {
		super(props)
		this.state = {
			selectedValues: [],
			idModal: UUID.v4()
		}
	}

	componentWillMount(): void {
		if (!this.props.selectionStatus.length) {
			AppStore.dispatch(SelectionAction.fetchSelectionStatus())
		}
	}

	shouldComponentUpdate(nextProps) {
		return (
			!isEqual(this.props.selections, nextProps.selections) ||
			!isEqual(this.props.selectionSites, nextProps.selectionSites) ||
			!isEqual(this.props.selectionFilters, nextProps.selectionFilters) ||
			!isEqual(this.props.filterValues, nextProps.filterValues) ||
			!isEqual(this.props.filterTypes, nextProps.filterTypes) ||
			!isEqual(this.props.selectionDetailsSites, nextProps.selectionDetailsSites) ||
			!isEqual(this.props.siteTypes, nextProps.siteTypes) ||
			!isEqual(this.props.themes, nextProps.themes) ||
			!isEqual(this.props.selectionKeyFigures, nextProps.selectionKeyFigures) ||
			!isEqual(this.props.selectionExportsHistory, nextProps.selectionExportsHistory) ||
			!isEqual(this.props.selectionWatershed, nextProps.selectionWatershed) ||
			!isEqual(this.props.selectionStatus, nextProps.selectionStatus) ||
			!isEqual(this.props.cities, nextProps.cities) ||
			!isEqual(this.props.watersheds, nextProps.watersheds) ||
			!isEqual(this.props.managementWaters, nextProps.managementWaters)
		)
	}

	componentDidUpdate() {
		$('.tooltipped').tooltip({ delay: 50 })
	}

	createInformation = (title, information) => {
		return (
			<div className='row no-margin'>
				<div className='col s6 no-padding'>
					{ title }
				</div>
				<div className='col s6 no-padding'>
					{ information }
				</div>
			</div>
		)
	}

	getInformations = (list, id) => {
		if (list.length > 0) {
			return filter(list, (o) => {
				return o.selectionId == id
			})
		}
		return []
	}
	getFilterSiteByTypes = (listOfSelectionSite, selectedSiteTypes) => {
		const listOfStations = intersectionWith(this.props.selectionDetailsSites, listOfSelectionSite, (a, b) => {
			return a.id == b.siteId
		})
		const piezometerToIntegrate = (() => {
			const piezometerParameterPresent = find(selectedSiteTypes, (o) => {
				return o.parameter == SiteTypes.PIEZOMETER.type
			})
			if (piezometerParameterPresent) {
				const filterPiezometerStation = filter(listOfStations, (o) => {
					return o.isPiezometer === '1'
				})
				const listOfPiezometers = filterPiezometerStation.map(o => {
					return Object.assign({}, o, {
						typeId: piezometerParameterPresent.id
					})
				})
				return listOfPiezometers
			}
			return []
		})()
		return [].concat(listOfStations, piezometerToIntegrate)
	}
	getStations = (list, id, selectedSiteTypes) => {
		if (list.length > 0) {
			const listOfSelectionSite = filter(list, (o) => {
				return o.selectionId == id
			})
			return this.getFilterSiteByTypes(listOfSelectionSite, selectedSiteTypes)
		}
		return []
	}
	getThemeId = () => {
		if (this.props.filterTypes.length) {
			const resultFilter = find(this.props.filterTypes, (o) => {
				return o.filter == ResearchTypes.THEME.type
			})
			if (resultFilter) {
				return resultFilter.id
			}
			return null
		}
		return null
	}

	getThemes = (filterValues, filters, themeId) => {
		if (themeId || themeId == '0' && filterValues.length && filters.length) {
			const intersections = intersectionWith(filterValues, filters, (a, b) => {
				return a.id == b.filterId
			})
			if (intersections.length) {
				return filter(intersections, (o) => {
					return o.filterTypeId == themeId
				})
			}
			return []
		}
		return []
	}
	getFiltersWithoutThemes = (filterValues, allFilters, themes) => {
		if (themes && themes.length && filterValues && filterValues.length) {
			const diff = differenceWith(allFilters, themes, (a, b) => {
				return a.id == b.id
			})
			return intersectionWith(filterValues, diff, (a, b) => {
				return a.id == b.filterId
			})
		}
		return allFilters
	}

	setModalSelectionInformation = (selection) => {
		AppStore.dispatch(SelectionAction.openModalSelectionInformation(selection))
	}

	setModalSelectionDelete = (selection) => {
		AppStore.dispatch(SelectionAction.openModalSelectionDelete(selection))
	}

	setModalSelectionExport = (selection) => {
		AppStore.dispatch(SelectionAction.openModalSelectionExport(selection))
	}
	setFavoriteFunction = (selection) => {
		if (selection.favorite) {
			AppStore.dispatch(SelectionAction.removeFavoriteSelection(selection))
		} else {
			AppStore.dispatch(SelectionAction.setFavoriteSelection(selection))
		}
	}

	createDtoRadius = (table) => {
		return table.map((o) => {
			const jsonValue = JSON.parse(o.value)
			return {
				label: 'x: ' + substringNumber(jsonValue.longi) + ' y: ' + substringNumber(jsonValue.lati) + ' radius: ' + parseFloat(jsonValue.radius),
				type: ResearchTypes.RADIUS,
				value: jsonValue
			}
		})
	}
	createDtoCity = (table) => {
		return table.map((o) => {
			const city = find(this.props.cities, (b) => {
				return b.code == o.value
			})
			const postalCode = city.postalCode ? city.postalCode : city.code
			return {
				label: city.name + ' - ' + postalCode + ' [' + city.code + ']',
				type: ResearchTypes.CITY,
				value: {
					code: o.value
				}
			}
		})
	}
	createDtoDepartment = (table) => {
		return table.map((o) => {
			const department = find(this.props.departments, (b) => {
				return b.code == o.value
			})
			return {
				label: department.name + ' [' + department.code + ']',
				type: ResearchTypes.DEPARTMENT,
				value: {
					code: o.value
				}
			}
		})
	}
	createDtoWatershed = (table) => {
		return table.map((o) => {
			const watershed = find(this.props.watersheds, (b) => {
				return b.id == o.value
			})
			return {
				label: watershed.name + ' [' + watershed.code + ']',
				type: ResearchTypes.WATERSHED,
				value: {
					code: o.value
				}
			}
		})
	}
	createDtoManagementWater = (table) => {
		return table.map((o) => {
			const managementWater = find(this.props.managementWaters, (b) => {
				return b.id == o.value
			})
			return {
				label: managementWater.name + ' [' + managementWater.code + ']',
				type: ResearchTypes.MANAGEMENT_WATER,
				value: {
					id: o.value
				}
			}
		})
	}
	createDtoStation = (table) => {
		return table.map((o) => {
			const station = find(this.props.selectionDetailsSites, (stat) => {
				return stat.id == o.value
			})
			return {
				label: station.name + ' [' + station.code + ']',
				type: ResearchTypes.STATION,
				value: {
					id: o.value
				}
			}
		})
	}

	lauchResearch = (selection) => {
		const reduceFilters = reduce(selection.filters, (a, b) => {
			(a[b.filterTypeId] || (a[b.filterTypeId] = [])).push(b)
			return a
		}, {})
		const selectedFilters = flatten(Object.keys(reduceFilters).map((o) => {
			const tabValue = reduceFilters[o]
			const filterTypeReference = find(this.props.filterTypes, (b) => {
				return b.id == o
			})
			switch (filterTypeReference.filter) {
				case ResearchTypes.RADIUS.type:
					return this.createDtoRadius(tabValue)
				case ResearchTypes.CITY.type:
					return this.createDtoCity(tabValue)
				case ResearchTypes.STATION.type:
					return this.createDtoStation(tabValue)
				case ResearchTypes.WATERSHED.type:
					return this.createDtoWatershed(tabValue, ResearchTypes.WATERSHED)
				case ResearchTypes.MANAGEMENT_WATER.type:
					return this.createDtoManagementWater(tabValue, ResearchTypes.MANAGEMENT_WATER)
				case ResearchTypes.DEPARTMENT.type:
					return this.createDtoDepartment(tabValue, ResearchTypes.DEPARTMENT)
				default:
					return null
			}
		}))
		const allThemes = flatten(this.props.themes.map(o => o.themes))
		const selectedThemes = uniqBy(selection.themes, 'value').map((o) => {
			const theme = find(allThemes, (b) => {
				return b.id == o.value
			})
			return {
				label: theme.title,
				value: theme
			}
		})
		SitesAction.launchResearch(selectedFilters, selectedThemes, this.props.filterTypes, selection)
	}


	getPictures = (urlPicture = '') => {
		if (urlPicture) {
			return urlPicture
		}
		return 'http://www.aquasys.fr/wp-content/uploads/2017/12/paul-gilmore-325220.jpg?id=1618'
	}

	getPicture = (themes, filters, stations) => {
		if (stations.length && this.props.selectionDetailsSites.length && this.props.themes) {
			const selectedSites = intersectionWith(this.props.selectionDetailsSites, stations, (a, b) => {
				return a.id == b.siteId
			})
			const reduceTypeId = reduce(selectedSites, (a, b) => {
				if (a[b.typeId]) {
					a[b.typeId] = a[b.typeId] + 1
				} else {
					a[b.typeId] = 1
				}
				return a
			}, {})
			const siteTypeParameters = Object.keys(reduceTypeId).map((o) => {
				const type = find(this.props.siteTypes, (a) => {
					return a.id == o
				})
				return {
					filter: type.parameter,
					count: reduceTypeId[o]
				}
			})
			const referencialTheme = intersectionWith(this.props.themes, themes, (a, b) => {
				return find(a.themes, (c) => {
					return c.id == b.value
				})
			})
			if (referencialTheme && referencialTheme.length) {
				if (referencialTheme.length > 1) {
					const resultThemes = reduce(referencialTheme, (a, b) => {
						const siteTypes = b.siteTypes
						const intersection = intersectionWith(siteTypeParameters, siteTypes, (c, d) => {
							return c.filter == d.type
						})
						a[b.id] = maxBy(intersection, (o) => {
							return o.count
						})
						return a
					}, {})
					const resultCount = Object.keys(resultThemes).map((o) => {
						if (resultThemes[o]) {
							return {
								id: o,
								count: resultThemes[o].count
							}
						}
						return undefined
					}).filter(n => n)
					const order = orderBy(resultCount, ['count'], ['desc'])
					if (order.length) {
						const themeSelected = find(this.props.themes, (o) => {
							return o.id == order[0].id
						})
						return this.getPictures(themeSelected.image)
					}

					return this.getPictures(referencialTheme[0].image)
				}
				return this.getPictures(referencialTheme[0].image)
			}
			return this.getPictures()
		}
		return this.getPictures()
	}
	getDeleteFunction = (selection, minimize = false) => {
		const color = '#F44336'
		if (minimize) {
			return (
				<Tooltip title={ i18n.deleteFunction }>
					<Icon className='material-icons' { ...css({
						width: 36,
						height: 36,
						color: color,
						fontSize: '2rem !important',
						margin: '7px !important'
					}) } onClick={ () => this.setModalSelectionDelete(selection) }> delete </Icon>
				</Tooltip>)
		}
		return (
			<Tooltip title={ i18n.deleteFunction }>
				<a className='btn-floating waves-effect waves-light z-depth-4 activator '
				   style={ {
					   backgroundColor: color,
					   width: 36,
					   height: 36
				   } }
				   onClick={ () => this.setModalSelectionDelete(selection) }>
					<i className='material-icons activator btn-function-card'>delete</i>
				</a>
			</Tooltip>
		)
	}


	getExecutionFunction = (selection, minimize = false) => {
		const color = '#2196F3'
		if (minimize) {
			return (
				<Tooltip title={ i18n.reflate }>
					<Icon className='material-icons' { ...css({
						width: 36,
						height: 36,
						color: color,
						fontSize: '2rem !important',
						margin: '7px !important'
					}) } onClick={ () => this.lauchResearch(selection) }> autorenew </Icon>
				</Tooltip>)
		}
		return (
			<Tooltip title={ i18n.reflate }>
				<a className='btn-floating waves-effect waves-light z-depth-4 activator '
				   style={ {
					   backgroundColor: color,
					   width: 36,
					   height: 36
				   } }
				   onClick={ () => this.lauchResearch(selection) }>
					<i className='material-icons activator btn-function-card'>autorenew</i>
				</a>
			</Tooltip>

		)
	}
	getInformationsFunction = (selection, minimize = false) => {
		const color = '#161832'
		if (minimize) {
			return (
				<Tooltip title={ i18n.informationFunction }>
					<Icon className='material-icons' { ...css({
						width: 36,
						height: 36,
						color: color,
						fontSize: '2rem !important',
						margin: '7px !important'
					}) } onClick={ () => this.setModalSelectionInformation(selection) }> info </Icon>
				</Tooltip>
			)
		}
		return (
			<Tooltip title={ i18n.informationFunction }>
				<a className='btn-floating waves-effect waves-light z-depth-4 activator '
				   style={ {
					   backgroundColor: color,
					   width: 36,
					   height: 36
				   } }
				   onClick={ () => this.setModalSelectionInformation(selection) }>
					<i className='material-icons activator btn-function-card'>info</i>
				</a>
			</Tooltip>
		)
	}
	getExportFunction = (selection, minimize = false) => {
		const color = '#4CAF50'
		if (minimize) {
			return (
				<Tooltip title={ i18n.exportFunction }>
					<Icon className='material-icons' { ...css({
						width: 36,
						height: 36,
						color: color,
						fontSize: '2rem !important',
						margin: '7px !important'
					}) } onClick={ () => this.setModalSelectionExport(selection) }> file_download </Icon>
				</Tooltip>
			)
		}
		return (
			<Tooltip title={ i18n.exportFunction }>
				<a className='btn-floating waves-effect waves-light z-depth-4 activator '
				   style={ {
					   backgroundColor: color,
					   width: 36,
					   height: 36
				   } }
				   onClick={ () => this.setModalSelectionExport(selection) }>
					<i className='material-icons activator btn-function-card'>file_download</i>
				</a>
			</Tooltip>
		)
	}
	getFavoriteFunction = (selection, minimize = false) => {
		const isFavorite = selection.favorite
		const color = isFavorite ? 'rgb(242, 161, 69) !important' : ''
		const backgroundColor = isFavorite ? 'rgba(0,0,255,0.6)' : ''
		const icon = isFavorite ? 'start' : 'star_border'
		const className = isFavorite ? 'favorit-color' : ''
		if (minimize) {
			return (
				<Tooltip title={ i18n.favorite }>
					<Icon className='material-icons' { ...css({
						width: 36,
						height: 36,
						color: color,
						fontSize: '2rem !important',
						margin: '7px !important'
					}) } onClick={ () => this.setFavoriteFunction(selection) }> { icon } </Icon>
				</Tooltip>
			)
		}
		return (
			<Tooltip title={ i18n.favorite }>
				<a className='btn-floating waves-effect waves-light z-depth-4 activator '
				   style={ {
					   backgroundColor: backgroundColor,
					   paddingLeft: color ? '8px' : 0,
					   color: color,
					   width: 36,
					   height: 36
				   } }
				   onClick={ () => this.setFavoriteFunction(selection) }>
					<i className={ 'material-icons activator btn-function-card ' + className }>{ icon }</i>
				</a>
			</Tooltip>
		)
	}
	getSelectionsPanel = (favoritSelection) => {
		const returnTable = []
		const resultFavorits = favoritSelection.map((o) => {
			const isUpdate = (() => {
				if (o.isUpdateData) {
					return (
						<div className='card-content no-padding no-margin center-align'>
							<div
								className='row no-margin updateColorBackground panelUpdate'>{ i18n.dataAvailable }</div>
						</div>
					)
				} else if (o.state) {
					const statusSelection = find(this.props.selectionStatus, a => o.state == a.id)
					if (statusSelection && statusSelection.id === 1) {
						return (
							<div className='card-content no-padding no-margin center-align'>
								<div
									className='row no-margin downloadColorBackground panelDownload'>{ statusSelection.name }</div>
								<LinearProgress className='white-filter' mode='indeterminate'
												style={ { height: '5px' } }/>
							</div>
						)
					}
					return (<div className='card-content no-padding no-margin' style={ { height: '25px' } }/>)
				}
				return (<div className='card-content no-padding no-margin' style={ { height: '25px' } }/>)
			})()
			return (
				<div className='col s2' key={ o.id }>
					<div className='card'>
						<div className='card-image'>
							<img className={ 'selectionPicturePanel' } src={ o.picture }/>
							<span className='card-title padding-bottom-0 padding-right-0 padding-top-0 padding-left-10' style={ { top: 0 } }>
								{ o.title }
							</span>
							<ul className='card-action-buttons right' style={ { margin: '-20px 10px 0 0' } }>
								<li style={ { display: 'inline-block', paddingLeft: '5px' } }>
									{ this.getInformationsFunction(o) }
								</li>
								<li style={ { display: 'inline-block', paddingLeft: '5px' } }>
									{ this.getExecutionFunction(o) }
								</li>
								<li style={ { display: 'inline-block', paddingLeft: '5px' } }>
									{ this.getExportFunction(o) }
								</li>
								<li style={ { display: 'inline-block', paddingLeft: '5px' } }>
									{ this.getDeleteFunction(o) }
								</li>
								<li style={ { display: 'inline-block', paddingLeft: '5px' } }>
									{ this.getFavoriteFunction(o) }
								</li>
							</ul>
						</div>
						<div className='card-content'>
							<div className='row no-margin'>
								<div className='col s12 no-padding'>
									{ this.createInformation(i18n.creation, getDate(o.creationDate)) }
									{ this.createInformation(i18n.update, getDate(o.updateDate)) }
									{ this.createInformation(i18n.lastExecutionDate, getDate(o.lastExecutionDate)) }
									{ this.createInformation(i18n.themes, formatNumber(o.nbTheme)) }
									{ this.createInformation(i18n.watersheds, formatNumber(o.nbWatershed)) }
									{ this.createInformation(i18n.stations, formatNumber(o.nbStation)) }
								</div>
							</div>
						</div>
						{ isUpdate }
					</div>
				</div>
			)
		})
		returnTable.unshift(resultFavorits)
		return returnTable
	}

	isUpdate = (selection, stations, keyFigures, exportHistory) => {
		if (exportHistory.length) {
			return filter(keyFigures, (a) => {
				return moment(a.endDate) >= moment(exportHistory[0].beginDate)
			}).length > 0
		}
		return true
	}

	getExportHistory = (selection) => {
		if (this.props.selectionExportsHistory && this.props.selectionExportsHistory.length) {
			const result = filter(this.props.selectionExportsHistory, (o) => {
				return o.selectionId == selection.id
			})
			if (result.length) {
				return orderBy(result, ['beginDate'], ['desc'])
			}
			return []
		}
		return []
	}
	getSelectionWatershed = (selection) => {
		if (this.props.selectionWatershed && this.props.selectionWatershed.length) {
			return filter(this.props.selectionWatershed, (o) => {
				return o.selectionId == selection.id
			})
		}
		return []
	}
	getSelectionKeyfigure = (stations) => {
		return filter(this.props.selectionKeyFigures, (o) => {
			return find(stations, (s) => {
				return o.stationId == s.id && o.typeId == s.typeId
			})
		})
	}
	getThemesWithSiteTypes = () => {
		const listOfThemesWithSiteType = flatten(this.props.themes.map(o => o.themes))
		return listOfThemesWithSiteType.map(o => {
			const siteTypes = filter(this.props.siteTypes, (si) => {
				return find(o.siteTypes, (tmp) => {
					return tmp.type == si.parameter
				})
			})
			return {
				themeId: o.id,
				siteTypes: siteTypes
			}
		})
	}
	getSelectionSiteTypes = (themes, referentialThemeSiteTypeIds) => {
		return flatten(filter(referentialThemeSiteTypeIds, (o) => {
			return find(themes, (t) => {
				return t.value == o.themeId
			})
		}).map((o) => {
			return o.siteTypes
		}))
	}
	getSelections = () => {
		if (this.props.selections.length) {
			const themeId = this.getThemeId()
			const referentialThemeSiteTypeIds = this.getThemesWithSiteTypes()
			return orderBy(filter(this.props.selections, o => !o.close), ['lastExecution'], ['desc']).map((o) => {
				const allFilters = this.getInformations(this.props.selectionFilters, o.id)
				const themes = this.getThemes(this.props.filterValues, allFilters, themeId)
				const selectedSiteTypes = this.getSelectionSiteTypes(themes, referentialThemeSiteTypeIds)
				const stations = this.getStations(this.props.selectionSites, o.id, selectedSiteTypes)
				const filters = this.getFiltersWithoutThemes(this.props.filterValues, allFilters, themes)
				const keyFigures = this.getSelectionKeyfigure(stations)
				const deleteFunction = this.getDeleteFunction(o, true)
				const favoriteFunction = this.getFavoriteFunction(o, true)
				const picture = this.getPicture(themes, filters, stations)
				const exportHistory = this.getExportHistory(o)
				const isUpdate = this.isUpdate(o, stations, keyFigures, exportHistory)
				const selectionWatershed = this.getSelectionWatershed(o)
				return new DtoSelectionRow(o, stations, filters,
					themes, picture, favoriteFunction, undefined, deleteFunction, undefined, undefined, isUpdate, exportHistory, selectionWatershed, keyFigures)
			}).map((o) => {
				return Object.assign({}, o, {
					executionFunction: this.getExecutionFunction(o, true),
					informationFunction: this.getInformationsFunction(o, true),
					exportFunction: this.getExportFunction(o, true)
				})
			})
		}
		return []
	}

	getAllInformations = () => {
		if (this.props.selections.length) {
			if (this.props.filterValues.length) {
				if (this.props.selectionDetailsSites.length) {
					if (this.props.watersheds.length) {
						if (this.props.cities.length) {
							return '100'
						}
						return i18n.loadingCities
					}
					return i18n.loadingWatershed
				}
				return i18n.loadingSelectedStations
			}
			return i18n.loadingYourFilters
		}
		return i18n.selectionLoading
	}

	getKeyfigures = () => {
		const selections = this.props.selections ? this.props.selections : []
		const nbSelection = selections.length
		const selectionSites = (() => {
			if (nbSelection) {
				return flatten(selections.map((o) => {
					return filter(this.props.selectionSites, (b) => {
						return b.selectionId === o.id
					})
				}))
			}
			return []
		})()
		const nbSite = selectionSites.length
		const keyFigures = (() => {
			if (nbSite) {
				return flatten(selectionSites.map((o) => {
					return filter(this.props.selectionKeyFigures, (b) => {
						return b.stationId === o.siteId
					})
				}))
			}
			return []
		})()
		const nbAnalysis = (() => {
			if (keyFigures.length) {
				return sumBy(filter(keyFigures, o => o.nbAnalysis), (o) => {
					return o.nbAnalysis
				})
			}
			return 0
		})()
		const nbMeasure = (() => {
			if (keyFigures.length) {
				sumBy(filter(keyFigures, o => o.nbMeasure), (o) => {
					return o.nbMeasure
				})
			}
			return 0
		})()
		const nbData = nbAnalysis + nbMeasure
		return [
			{
				title: getPlurialWithNumber(i18n.selection, i18n.selections, nbSelection),
				number: nbSelection
			},
			{
				title: getPlurialWithNumber(i18n.station, i18n.stations, nbSite),
				number: nbSite
			},
			{
				title: getPlurialWithNumber(i18n.data, i18n.datas, nbData),
				number: nbData
			}
		]
	}

	getFavoritResearchPanel = (selections) => {
		const favoriteResearch = filter(selections, o => o.favorite)
		if (favoriteResearch.length) {
			const lastSelectionTitle = getPlurial(i18n.favoriteResearch, i18n.favoriteResearchs, favoriteResearch)
			if (favoriteResearch.length > 5) {
				return (
					<div className='col s12 no-padding'>
						<div className='row'>
							<div className='col s12 center-align white-filter-fill'>
								<h4><span>{ lastSelectionTitle }</span></h4>
							</div>
							<div id='favoritSelection' className='col s12 no-padding white-filter'>
								<div className='col s12 no-padding'>
									<div className='row'>
										<AgGridTable datas={ favoriteResearch } type={ new DtoSelectionRow({}) }
													 cellHeight={ 45 }/>
									</div>
								</div>
							</div>
						</div>
					</div>
				)
			}
			return (
				<div className='col s12 no-padding'>
					<div className='row'>
						<div className='col s12 center-align white-filter-fill'>
							<h4><span>{ lastSelectionTitle }</span></h4>
						</div>
						<div id='favoritSelection' className='col s12 no-padding white-filter'>
							<div className='row no-margin'>
								<div className='col s12 offset-s1 no-padding '>
									<div className='row no-margin '>
										{ this.getSelectionsPanel(favoriteResearch) }
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			)
		}
		return null
	}

	render() {
		const loadingValue = this.getAllInformations()
		if (loadingValue === '100') {
			const selections = this.getSelections()
			const saveSelectionTitle = getPlurial(i18n.saveResearch, i18n.saveResearchs, selections)
			if (selections && selections.length) {
				return (
					<div className='row no-margin'>
						<SelectionInformationModal/>
						<SelectionDeleteModal/>
						<SelectionExportModal/>
						{ this.getFavoritResearchPanel(selections) }
						<div>
							<div className='col s12 center-align white-filter-fill'>
								<h4><span>{ saveSelectionTitle }</span></h4>
							</div>
							<div className='col s12 z-depth-3 white-filter' style={ { marginBottom: '6rem' } }>
								<div className='row no-margin'>
									<div className='col s12 no-padding' style={ { marginBottom: '10px' } }>
										<IndicatorPanel datas={ this.getKeyfigures() }/>
									</div>
								</div>
								<div className='row no-margin'>
									<AgGridTable datas={ selections } type={ new DtoSelectionRow({}) }
												 cellHeight={ 45 }/>
								</div>
							</div>
						</div>
					</div>
				)
			}
		}
		return (<LoadingPanel title={ loadingValue }/>)
	}

}

SelectionsPanel.propTypes = {
	selections: PropTypes.arrayOf(PropTypes.objectOf(DtoSelection)),
	selectionSites: PropTypes.arrayOf(PropTypes.objectOf(DtoSelectionSite)),
	selectionFilters: PropTypes.arrayOf(PropTypes.objectOf(DtoSelectionFilter)),
	filterValues: PropTypes.arrayOf(PropTypes.objectOf(DtoFilter)),
	filterTypes: PropTypes.arrayOf(PropTypes.objectOf(DtoFilterType)),
	selectionDetailsSites: PropTypes.arrayOf(PropTypes.objectOf(DtoSelectionDetailSite)),
	siteTypes: PropTypes.arrayOf(PropTypes.objectOf(DtoSiteType)),
	themes: PropTypes.arrayOf(PropTypes.objectOf(ThemeDto)),
	selectionKeyFigures: PropTypes.arrayOf(PropTypes.objectOf(DtoKeyFigures)),
	selectionExportsHistory: PropTypes.arrayOf(PropTypes.objectOf(DtoSelectionExportHistory)),
	selectionWatershed: PropTypes.arrayOf(PropTypes.objectOf(DtoSelectionWatershed)),
	selectionStatus: PropTypes.arrayOf(PropTypes.objectOf(DtoSelectionStatus)),
	cities: PropTypes.arrayOf(PropTypes.objectOf(DtoCity)),
	departments: PropTypes.arrayOf(PropTypes.objectOf(DtoDepartment)),
	watersheds: PropTypes.arrayOf(PropTypes.objectOf(DtoWatershed)),
	managementWaters: PropTypes.arrayOf(PropTypes.objectOf(DtoManagementWater))
}

const mapStateToProps = store => {
	return {
		selectionSites: store.SelectionReducer.selectionSites,
		selectionFilters: store.SelectionReducer.selectionFilters,
		filterValues: store.SelectionReducer.filterValues,
		filterTypes: store.ReferentialReducer.filterTypes,
		siteTypes: store.ReferentialReducer.siteTypes,
		selectionDetailsSites: store.SelectionReducer.selectionDetailsSites,
		themes: store.AdministrationReducer.themes,
		selectionKeyFigures: store.SelectionReducer.selectionKeyFigures,
		selectionExportsHistory: store.SelectionReducer.selectionExportsHistory,
		selectionWatershed: store.SelectionReducer.selectionWatershed,
		selectionStatus: store.SelectionReducer.selectionStatus,
		cities: store.ReferentialReducer.cities,
		departments: store.ReferentialReducer.departments,
		watersheds: store.ReferentialReducer.watersheds,
		managementWaters: store.ReferentialReducer.managementWaters
	}
}

export default connect(mapStateToProps)(SelectionsPanel)



// WEBPACK FOOTER //
// ./src/dashboard/components/selections/SelectionsPanel.js